/* istanbul ignore file */

export const RELATED_CATEGORIES_ID = 'related-categories';
